import React from 'react';

const SvgWarningIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="m18.108 15 -6.667 -11.667a1.667 1.667 0 0 0 -2.9 0l-6.667 11.667A1.667 1.667 0 0 0 3.333 17.5h13.333a1.667 1.667 0 0 0 1.442 -2.5" />
    <path d="M10 7.5v3.333" />
    <path d="M10 14.167h0.008" />
  </svg>
);

export default SvgWarningIcon;